"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unpackToRawClusterProxyArgs = exports.packRawClusterProxyArgs = exports.ClusterProxyArgs = void 0;
const bi_1 = require("@ckb-lumos/bi");
const base_1 = require("@ckb-lumos/base");
const codec_1 = require("@ckb-lumos/codec");
const utils_1 = require("./utils");
exports.ClusterProxyArgs = (0, codec_1.createBytesCodec)({
    pack(packable) {
        const id = base_1.blockchain.Byte32.pack(packable.id);
        const minPayment = utils_1.Uint8Opt.pack(packable.minPayment);
        const composed = new Uint8Array(id.length + minPayment.length);
        composed.set(id, 0);
        composed.set(minPayment, id.length);
        return composed;
    },
    unpack(unpackable) {
        const id = base_1.blockchain.Byte32.unpack(unpackable.slice(0, 32));
        const minPayment = utils_1.Uint8Opt.unpack(unpackable.slice(32, 33));
        return {
            id,
            minPayment: typeof minPayment === 'number' ? bi_1.BI.from(minPayment) : void 0,
        };
    },
});
function packRawClusterProxyArgs(packable) {
    return exports.ClusterProxyArgs.pack(packable);
}
exports.packRawClusterProxyArgs = packRawClusterProxyArgs;
function unpackToRawClusterProxyArgs(unpackable) {
    return exports.ClusterProxyArgs.unpack(unpackable);
}
exports.unpackToRawClusterProxyArgs = unpackToRawClusterProxyArgs;
//# sourceMappingURL=clusterProxy.js.map